import { cn } from "@devhop/ui";
import { Building2Icon, MapPinIcon } from "lucide-react";

export type PrivateLessonLocationKind = "studio" | "off_site";

type PrivateLessonLocationKindRadioProps = {
  value: PrivateLessonLocationKind;
  onChange: (value: PrivateLessonLocationKind) => void;
  onBlur?: () => void;
  name?: string;
  disabled?: boolean;
  label?: string;
};

const OPTIONS: Array<{
  value: PrivateLessonLocationKind;
  title: string;
  description: string;
  Icon: typeof Building2Icon;
}> = [
  {
    value: "studio",
    title: "ພາຍໃນສະຕູດິໂອ",
    description: "ຕ້ອງເລືອກຫ້ອງຕອນຈອງ",
    Icon: Building2Icon,
  },
  {
    value: "off_site",
    title: "ນອກສະຖານທີ່",
    description: "ຈອງເປັນເວລາຄູ — ບໍ່ໃຊ້ຫ້ອງ",
    Icon: MapPinIcon,
  },
];

export function PrivateLessonLocationKindRadio({
  value,
  onChange,
  onBlur,
  name = "defaultLocationKind",
  disabled = false,
  label = "ສະຖານທີ່ເລີ່ມຕົ້ນ",
}: PrivateLessonLocationKindRadioProps) {
  return (
    <fieldset className="min-w-0 border-0 p-0">
      <legend className="mb-2 font-medium text-sm">{label}</legend>
      <div className="grid gap-3 sm:grid-cols-2">
        {OPTIONS.map(({ value: optValue, title, description, Icon }) => {
          const selected = value === optValue;
          return (
            <label
              key={optValue}
              className={cn(
                "flex cursor-pointer gap-3 rounded-lg border p-4 text-left ring-offset-background transition-colors focus-within:outline-none focus-within:ring-2 focus-within:ring-red-600 focus-within:ring-offset-2",
                disabled && "cursor-not-allowed opacity-60",
                selected
                  ? "border-red-600 bg-muted/50"
                  : "border-border hover:bg-muted/30",
              )}
            >
              <input
                type="radio"
                name={name}
                value={optValue}
                checked={selected}
                disabled={disabled}
                onChange={() => onChange(optValue)}
                onBlur={onBlur}
                className="sr-only"
              />
              <Icon
                className={cn(
                  "mt-0.5 size-5 shrink-0 stroke-[1.5]",
                  selected ? "text-red-600" : "text-muted-foreground",
                )}
                aria-hidden
              />
              <span className="min-w-0 space-y-1">
                <span className="block font-semibold text-sm leading-tight">
                  {title}
                </span>
                <span className="block text-muted-foreground text-xs leading-snug">
                  {description}
                </span>
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
